module.exports = __webpack_public_path__ + "static/search-background-20eabaed2e72cf51d3cd2dafc5b49efd.png";